import * as Dfns from 'date-fns/fp';
import { CURRENT_WEEK_START, DATE_FORMAT } from '@src/utils/date-utils';

export const S3_BUCKET_LOCATION = 'bpm-reconcile';

export const PAGE_TITLE = 'Process Post Logs';

export const DownloadTarget = {
  EXCEL: 'excel',
  CSV: 'csv'
} as const;
export type DownloadTargetType = (typeof DownloadTarget)[keyof typeof DownloadTarget];

export const PARSE_POST_LOGS_JOB_PARAMS = {
  job_name: 'parsePostLogs',
  streamingType: 'streaming',
  input_branch: 'v2',
  memory: 58880
} as const;

export const PARSE_POST_LOGS_JOB_CONFIG = {
  jobQueue: 'dag-ondemand-large',
  kpi: 'none',
  startScript: './scripts/ingest-streaming-job.sh',
  codeDirectory: 'blisspointmedia',
  jobDefinition: 'streaming-job-java-amazonlinux2023-arm64'
} as const;

export const CUTOFF_DATE = Dfns.format(
  DATE_FORMAT,
  Dfns.addWeeks(1, Dfns.parseISO(CURRENT_WEEK_START))
);

export const getDefaultWeek = (): string =>
  Dfns.format(DATE_FORMAT, Dfns.subWeeks(1, Dfns.parseISO(CURRENT_WEEK_START)));

export interface RawPostLogRow {
  company: string;
  network: string;
  satelliteNetwork: string;
  length: string;
  cost: number;
}

export interface ProcessedPostLogRow {
  company: string;
  network: string;
  satelliteNetwork: string;
  length: string;
  count: number;
  spend: number;
}
